import React, { useEffect, useState, useCallback } from "react";
import { generateExcel, getHeaderColNames, excelColorCodes, transformNavDataForLabels, getUserID } from "./../../utils";
import { proxy } from '../../process/api';
import ReportOptions from "./../ReportOptions";
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import { useNavigate } from "react-router-dom";


const TL05 = () => {
    const [pageTitle, setPageTitle] = useState('');
    const [loginErrorMessage, setLoginErrorMsg] = useState('');
    const currentToken = localStorage.getItem('token');
    const [isValid, setIsValid] = useState(true);
    const [fName, setFName] = useState('');
    const [loginName, setLoginName] = useState('');
    const [isLoginError, setLoginError] = useState(false);
    const [isSuccess, setisSuccess] = useState(false);
    const [showProcessLoader, setShowProcessLoader] = useState(false);
    const [showOptions, setShowOptions] = useState(true);
    const [fileName, setFileName] = useState(null); // New state for file name
    const [uploadProgress, setUploadProgress] = useState(0); // New state for upload progress
    const [uploadedFile, SetuploadedFile] = useState('');
    const [total_records, setTotalRecords] = useState(0);
    const [processed_records, setprocessed_records] = useState(0);
    const [btnName, setBtnName] = useState('Process Uploaded File');
    

    const navigate = useNavigate();

    const onDrop = useCallback(async (acceptedFiles) => {
        const formData = new FormData();
        formData.append('file', acceptedFiles[0]); // Assumes single file upload

        // Set file name for display
        setFileName(acceptedFiles[0].name);

        try {
            const response = await axios.post('https://mobile.aristopharma.co.in/api/route/do-files', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(percentCompleted);
                },
            });
            console.log('File uploaded successfully:', response.data.message);
            SetuploadedFile(response.data.filePath);
        } catch (error) {
            console.error('Error uploading file:', error);
            alert('Error uploading file:', error);
        }
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    const handleSubmit = async () => {

        setBtnName('Wait...');
        const now = new Date();

        const hours = now.getHours();
        const minutes = now.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';

        const formattedHours = hours % 12 || 12; // Converts 0 to 12 for 12 AM or PM
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;

        const currentTime = `${formattedHours}:${formattedMinutes} ${ampm}`;


        const fileName = uploadedFile.split('/').pop();
        const dirPath = uploadedFile.split('/').slice(0, -1).join('/');

        const payload = {
            file_path: dirPath + "/",
            file_name: fileName,

        }
        const apiResponse = await proxy(`/api/mis/uploadfieldsetup`, payload, "post");
        if(apiResponse.message == "SUCCESS"){
            setShowOptions(false);

            checkStatus(); // initial call
        const intervalId = setInterval(checkStatus, 20000);
    
        // Optionally, clear the interval when the component unmounts or when the task is completed
        return () => clearInterval(intervalId);
        }else{
            alert(apiResponse.data.message);
            setBtnName('Process Uploaded File');
        }
       


    };

    const checkStatus = async () => {
        const statusResponse = await proxy(`/api/mis/showprocessrecords`, {}, "get");

        setTotalRecords(statusResponse.no_of_records);
        setprocessed_records(statusResponse.no_of_records_processed);
        
    };


    useEffect(() => {
        transformNavDataForLabels("TL05").then(title => setPageTitle(title));
    }, []);

    return (
        <div className="main-content">
            {showOptions ? (
                <ReportOptions title="Upload File">
                    <div className="report-option-wrapper">
                        <div className="report-option">
                            <div className="report-option-item" style={{ flexDirection: 'column' }}>
                                <div {...getRootProps()} style={{
                                    border: '2px dashed #cccccc',
                                    padding: '20px',
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    color: '#555',
                                    width: '100%'
                                }}>
                                    <input {...getInputProps()} />
                                    {isDragActive ? (
                                        <p>Drop the file here...</p>
                                    ) : (
                                        <p>Drag 'n' drop a file here, or click to select one</p>
                                    )}
                                </div>
                                {/* Display file name if uploaded */}
                                {fileName && <p>Selected file: {fileName}</p>}
                                {/* Display progress bar during upload */}
                                {uploadProgress > 0 && uploadProgress < 100 && (
                                    <div style={{ width: "180px", textAlign: "center" }}>
                                        <progress value={uploadProgress} max="100" />
                                        <p>{uploadProgress}%</p>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="report-option-action-row" style={{ marginTop: "20px" }}>
                            <br />
                            <button onClick={() => navigate('/dashboard')} className="btn btn-outline btn-md btn-sec mr-10 fw-500">BACK</button>
                            <button onClick={handleSubmit} className="btn btn-md btn-primary pr-30 pl-30 fw-500" id="btnReportGen">{btnName}</button>
                        </div>
                    </div>
                </ReportOptions>
            ) : (
                <div className="row">
                    <div className="col-12">
                        <div className="card report-card" style={{ width: "auto", minWidth: "auto" }} >

                            <div className="card-title report-card-title">Data Processing Status
                                <button className="btn btn-outline btn-md  mr-10 fw-500" onClick={(e) => { window.location.reload() }}>BACK</button>
                            </div>

                            <div className="card-body">


                                <div className="row">
                                <div class="col-3">

<div className="card" style={{border:"1px solid #eee"}}>
<div className="card-body text-center">
    
<h1>{processed_records}</h1>
     <h5>PROCESSED RECORDS</h5>
     
    </div>
     
     
     </div>
</div> 

                                    <div class="col-3">

                                    <div className="card" style={{border:"1px solid #eee"}}>
                                    <div className="card-body text-center">
                                        
                                    <h1>{total_records}</h1>
                                         <h5>TOTAL RECORDS</h5>
                                         
                                        </div>
                                         
                                         
                                         </div>
                                    </div> 

                                  

                                    
                                                  </div>
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TL05;
